import Actions from 'flow/actions';
import { FeatureFlagObject } from 'flow/types/FeatureFlags';

export const getAndSetFeatureFlags = (featureFlags: FeatureFlagObject[]) => ({
    type: Actions.GET_SET_WEB_CLIENT_FEATURE_FLAGS,
    ...featureFlags,
});
